module.exports = __webpack_public_path__ + "static/media/pic99.cb749f39.jpg";